

import { Button, Popconfirm, Space, Tooltip,Switch  } from 'antd';
import React from 'react'
import { DeleteOutlined, QuestionCircleOutlined, FileSearchOutlined, EyeOutlined, FormOutlined } from '@ant-design/icons';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import { MdLockReset } from "react-icons/md";

export default function ButtonAction({
    children,
    buttons = [],
    onView = () => { },
    onEdit = () => { },
    onDelete = () => { },
    onSelect = () => { },
    onAdd = () => { },
    onApproval = () => { },
    onResetPassword = () => { },
    onToggleStatus = () => { },
    txtBtnSelect = "Select",
    txtBtnAdd = "Add",
    data,
    tooltipView = "view",
    tooltipEdit = "edit",
    tooltipDelete = "delete",
    tooltipSelect = "select",
    tooltipAdd = "add",
    tooltipApproval = "approval",
    fieldStatus = "status", // ✅ tambahkan ini

}) {
    const isMobile = useIsMobileHooks()

    const sizeBtn = isMobile ? 'middle' : 'small'
    const shapeBtn = 'default'
    const masterButtons = {
        view: (
            <Tooltip title={tooltipView}>
                <Button size={sizeBtn} shape={shapeBtn} type="dashed" icon={<EyeOutlined />} onClick={(e) => {
                    e.stopPropagation();
                    onView(data)
                }} />
            </Tooltip>),
        edit: (
            <Tooltip title={tooltipEdit}>
                <Button size={sizeBtn} shape={shapeBtn} type="primary" icon={<FormOutlined />} onClick={(e) => {
                    e.stopPropagation();
                    onEdit(data)
                }} />
            </Tooltip>),
        delete: (
            <Popconfirm
                title="Sure to delete?"
                icon={<QuestionCircleOutlined
                    style={{ color: 'red' }} />
                }
                onClick={(e) => {
                    e.stopPropagation()
                }}
                onConfirm={(e) => {
                    e.stopPropagation()
                    onDelete(data)
                }}
                onCancel={(e) => {
                    e.stopPropagation()
                }}
                on>
                <>
                    <Tooltip title={tooltipDelete}>
                        <Button size={sizeBtn} shape={shapeBtn} danger icon={<DeleteOutlined />} />
                    </Tooltip>
                </>
            </Popconfirm>),

         // ✅ Tambahkan ini
        toggleStatus: (
            <Tooltip title="Toggle Status">
                <Switch
                    checked={data?.[fieldStatus] === "true"}
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    onClick={(e) => e.stopPropagation()}
                    onChange={(checked) => {
                        onToggleStatus(data, checked);
                    }}
                    style={{
                        backgroundColor: data?.[fieldStatus] === "true" ? '#3b5998' : undefined
                    }}
                />
            </Tooltip>
        ),
        select: (
            <Tooltip title={tooltipSelect}>
                <Button size={sizeBtn} shape={shapeBtn} type="primary"
                    // icon={<CheckCircleOutlined />}
                    onClick={onSelect}>
                    {txtBtnSelect}</Button>
            </Tooltip>),
        add: (
            <Tooltip title={tooltipAdd}>
                <Button size={sizeBtn} shape={shapeBtn} type="primary"
                    // icon={<CheckCircleOutlined />}
                    onClick={onAdd}>
                    {txtBtnAdd}
                </Button>
            </Tooltip>),
        approval: (
            <Tooltip title={tooltipApproval}>
                <Button size={sizeBtn} shape={shapeBtn} type="primary" icon={<FileSearchOutlined />} onClick={(e) => {
                    e.stopPropagation();
                    onApproval(data)
                }} />
            </Tooltip>),
        resetPassword: (
            <Tooltip title={"reset password"}>
                <Button size={sizeBtn} shape={shapeBtn} icon={<MdLockReset size={18} style={{ verticalAlign: "text-bottom" }} />} onClick={(e) => {
                    e.stopPropagation();
                    onResetPassword(data)
                }} />
            </Tooltip>),
    };

    // useEffect(() => {
    //     setIsOpen(confirmLoading)
    // }, [confirmLoading])


    return (
        <Space className='space-vertical-flex wrap-button-action'>
            {/* <Button.Group> */}
            {buttons?.sort((a, b) => {
                const order = { 'view': 1, 'edit': 2, 'delete': 3, toggleStatus: 4 };
                return order[a] - order[b];
            }).map((button, index) => <div key={index}>{masterButtons[button]}</div>)}
            {/* </Button.Group> */}
        </Space>
    )
}
